import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { IoClose } from 'react-icons/io5';
import { HiArrowRight } from 'react-icons/hi';

// Separate components for better organization
const ComingSoonRibbon = () => (
  <div className="relative animate-pulse">
    <div className="relative overflow-hidden group">
      <div className="absolute inset-0 bg-white/10 backdrop-blur-sm transform -skew-x-12" />
      <div className="relative bg-white/5 backdrop-blur-md border border-white/20 px-6 py-2 
        text-white font-semibold transform -skew-x-12 shadow-lg shadow-white/10 animate-glow">
        <span className="inline-block transform skew-x-12 text-sm md:text-base relative z-10">
          Coming Soon
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent 
            animate-shimmer -z-10" />
        </span>
      </div>
      <div className="absolute -left-2 bottom-0 w-2 h-2 bg-white/20 backdrop-blur-sm" />
    </div>
  </div>
);

const EventDetails = () => (
  <div className="flex flex-col items-center justify-center mx-4 flex-1">
    <div className="flex flex-col items-center">
      <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-white animate-fadeIn">
        RISEUP 2.0
      </h3>
      <p className="text-sm text-white/80 animate-fadeIn">End of May 2025</p>
    </div>
  </div>
);

const ViewEventsButton = () => (
  <Link 
    to="/events"
    className="relative group bg-white/10 backdrop-blur-md px-2 py-1 md:px-4 md:py-2 rounded-md 
      border border-white/20 transition-all duration-300 hover:bg-white/20 flex items-center gap-1 md:gap-2
      hover:scale-105 transform"
  >
    <span className="text-xs md:text-sm font-medium text-white group-hover:text-white/90">
      View Events
    </span>
    <HiArrowRight className="w-3 h-3 md:w-4 md:h-4 transform group-hover:translate-x-1 transition-transform" />
  </Link>
);

const EventDetailsModal = ({ onClose }) => (
  <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center">
    <div className="bg-[#04236B] p-6 rounded-lg max-w-md w-full mx-4">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-xl font-bold text-white">RISEUP 2.0 Details</h3>
        <button 
          onClick={onClose}
          className="text-white/80 hover:text-white"
        >
          <IoClose size={24} />
        </button>
      </div>
      <div className="space-y-4 text-white/80">
        <p>Join us for an exciting event at Galgotias University Campus!</p>
        <p>Date: End of May 2025</p>
        <p>Location: Noida</p>
        <Link 
          to="/events"
          className="inline-block mt-4 bg-[#FF9900] px-6 py-2 rounded-md text-white font-semibold hover:bg-[#FF9900]/90 transition-all"
        >
          Learn More
        </Link>
      </div>
    </div>
  </div>
);

const EventsBanner = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [showEventDetails, setShowEventDetails] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  if (!isHomePage || !isVisible) return null;

  return (
    <>
      <div className="relative w-full bg-[#04236B] text-white">
        <div className="max-w-7xl mx-auto px-2 md:px-4 py-2 md:py-3 relative animate-slideDown">
          <div className="flex items-center justify-between w-full gap-1 md:gap-4">
            <div className="flex-shrink-0">
              <ComingSoonRibbon />
            </div>
            <EventDetails />
            <div className="flex items-center gap-1 md:gap-4">
              <ViewEventsButton />
              <button 
                onClick={() => setIsVisible(false)}
                className="text-white/80 hover:text-white transition-colors duration-300"
                aria-label="Close banner"
              >
                <IoClose className="w-4 h-4 md:w-6 md:h-6" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {showEventDetails && <EventDetailsModal onClose={() => setShowEventDetails(false)} />}
    </>
  );
};

export default EventsBanner;

// Add these styles to your tailwind.config.js
/*
module.exports = {
  theme: {
    extend: {
      keyframes: {
        shimmer: {
          '0%': { transform: 'translateX(-100%)' },
          '100%': { transform: 'translateX(100%)' }
        },
        glow: {
          '0%, 100%': { opacity: 1 },
          '50%': { opacity: 0.8 }
        },
        fadeIn: {
          '0%': { opacity: 0 },
          '100%': { opacity: 1 }
        },
        slideDown: {
          '0%': { transform: 'translateY(-100%)' },
          '100%': { transform: 'translateY(0)' }
        }
      },
      animation: {
        shimmer: 'shimmer 2s infinite',
        glow: 'glow 2s ease-in-out infinite',
        fadeIn: 'fadeIn 0.5s ease-out',
        slideDown: 'slideDown 0.5s ease-out'
      }
    }
  }
}
*/ 